import React, { useState, useEffect } from "react";
import {
  TiArrowSortedUp,
  TiArrowUnsorted,
  TiArrowSortedDown,
} from "react-icons/ti";
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  Sorting,
} from "@tanstack/react-table";
import TablePagination from "../pagination/TablePagination";

const { SortingState } = Sorting;

const ReactTable = ({
  data,
  columns,
  paginationData,
  showPagination = true,
  className = "",
  sortedBy = {},
  onColumnSort = () => {},
}) => {
  const [sorting, setSorting] = useState(SortingState || [sortedBy]);

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    sortDescFirst: true,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  // Use effect to apply sorting when column clicked
  useEffect(() => {
    if (
      sorting &&
      sorting.length !== 0 &&
      (sorting[0].id !== sortedBy.id || sorting[0].desc !== sortedBy.desc)
    ) {
      onColumnSort(sorting[0]);
    }
    // eslint-disable-next-line
  }, [sorting]);

  return (
    <>
      <div className={`table-container ${className}`}>
        <table className="responsive-table">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    style={{ width: header.column.columnDef.size + "px" }}
                    {...{
                      className: header.column.getCanSort()
                        ? "cursor-pointer"
                        : "",
                      onClick: header.column.getToggleSortingHandler(),
                    }}
                  >
                    <div
                      className={
                        header.column.columnDef?.enableSorting
                          ? "d-flex align-items-center"
                          : ""
                      }
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {header.column.columnDef?.enableSorting && (
                        <span className="ps-1">
                          {sorting.length &&
                          header.getContext().column.id === sortedBy.id ? (
                            sortedBy.desc ? (
                              <TiArrowSortedDown />
                            ) : (
                              <TiArrowSortedUp />
                            )
                          ) : (
                            <TiArrowUnsorted />
                          )}
                        </span>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {data?.length > 0 ? (
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No result found
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      {showPagination && paginationData?.totalItems > 0 && (
        <div className="mt-3">
          <TablePagination paginationData={paginationData} />
        </div>
      )}
    </>
  );
};

export default ReactTable;
